const urlJoin = require('url-join');
const { siteUrl, defaultLocale } = require('.');
const {
    genHome, genProductJSONLd, genProductSpecJSONLd, genBreadCrumb, genCategoryJSONLd, genDefaultJsonLd, genBlogJSONLd,
} = require('./jsonld');

const companyName = {
    'zh-hant': '建臺有限公司',
};

const appendCompanyName = (text, locale = defaultLocale) => `${text} | ${companyName[locale]}`;

const genIndex = (locale = defaultLocale) => ({
    title: appendCompanyName('最專業的漆包線、電線電纜、銅材供應商', locale),
    subtitle: '建臺有限公司是擁有40年豐富經驗的漆包線、電線電纜、銅材、電容器、絕緣材料、凡立水、絕緣紙等各式馬達電機材料供應商，為您提供最頂尖的產業產品',
});

const genProducts = (locale = defaultLocale) => ({
    title: appendCompanyName('所有產品', locale),
    subtitle: '建臺有限公司提供最齊全的漆包線、凡利水、端子、諾美士絕緣紙、銅材、電容器、離心開關、絕緣材料、配線器材、各種漆包線相關工具供應商',
});

const genContact = (locale = defaultLocale) => ({
    title: appendCompanyName('聯絡我們', locale),
    subtitle: '建臺有限公司成立於 1981 年，深耕臺灣機械電機產業四十餘載，除了提供客戶電線電纜、電機機械、馬達/變壓器等製造修護相關零組件的一站式採購外，更是「大亞電線電纜集團」35年的優良經銷商。',
});

const genAbout = (locale = defaultLocale) => ({
    title: appendCompanyName('關於我們', locale),
    subtitle: '聯絡建台有限公司，為您提供台南、嘉義、雲林、高雄、屏東、彰化、台中等全台灣各地的漆包線、凡立水、銅材等電機材料採購服務',
});

const genCategory = (locale = defaultLocale, meta) => ({
    title: appendCompanyName(meta.name, locale),
    subtitle: meta.seo_desc,
});

const genProduct = (locale = defaultLocale, meta) => ({
    title: appendCompanyName(meta.name, locale),
    subtitle: meta.seo_desc,
});

const genNews = (locale = defaultLocale) => ({
    title: appendCompanyName('資訊分享', locale),
    subtitle: '建臺有限公司分享的電機電子產業資訊，包含漆包線、凡利水、端子、諾美士絕緣紙、銅材、電容器、離心開關、絕緣材料、配線器材、各種漆包線產品介紹',
});

const genNewsPost = (locale = defaultLocale, meta) => ({
    title: appendCompanyName(meta.title, locale),
    subtitle: meta.seo_desc,
});

const genAnnouncement = (locale = defaultLocale) => ({
    title: appendCompanyName('公告', locale),
    subtitle: '建臺有限公司公告資訊。此頁面將不定期分享最新的企業公告',
});

const genAnnouncementPost = (locale = defaultLocale, meta) => ({
    title: appendCompanyName(meta.title, locale),
    subtitle: meta.seo_desc,
});

const genProductSpec = (locale = defaultLocale, meta) => ({
    title: appendCompanyName(`${meta.specName} | ${meta.product.name}`, locale),
    subtitle: meta.seo_desc,
});

const genDefault = (locale = defaultLocale) => ({
    title: companyName[locale],
    subtitle: '專業銷售漆包線、漆包絞線、鍍錫線、裸銅及裸銅絞線及其他特殊線材。成為廠商最信賴的材料供應廠商，我們的品質與服務，以客戶滿意為第一優先',
});

const genSEO = ({
    pagePath, locale, url, meta, canonicalUrl,
}) => {
    let seo;
    let jsonld = genDefaultJsonLd();
    const pageUrl = urlJoin(siteUrl, url, url !== '/' ? '/' : '');

    switch (pagePath) {
    case '/':
        seo = genIndex(locale);
        jsonld = [
            ...jsonld,
            genHome(),
        ];
        break;
    case '/products/':
        seo = genProducts(locale);
        break;
    case '/contact/':
        seo = genContact(locale);
        break;
    case '/about/':
        seo = genAbout(locale);
        break;
    case '/news/':
        seo = genNews(locale);
        break;
    case '/announcement/':
        seo = genAnnouncement(locale);
        break;
    case 'category':
        seo = genCategory(locale, meta);
        jsonld = [
            ...jsonld,
            genBreadCrumb([{
                url: meta.fullSiteUrl,
                name: meta.name,
            }]),
            genCategoryJSONLd(meta, pageUrl),
        ];
        break;
    case 'product':
        seo = genProduct(locale, meta);
        jsonld = [
            ...jsonld,
            genProductJSONLd(meta, pageUrl),
            genBreadCrumb([
                {
                    url: meta.categoryData.url,
                    name: meta.categoryData.name,
                },
                {
                    url: meta.fullSiteUrl,
                    name: meta.name,
                },
            ]),
        ];
        break;
    case 'news':
        seo = genNewsPost(locale, meta);
        jsonld = [
            ...jsonld,
            genBlogJSONLd(meta),
        ];
        break;
    case 'announcement':
        seo = genAnnouncementPost(locale, meta);
        jsonld = [
            ...jsonld,
            genBlogJSONLd(meta),
        ];
        break;
    case 'productSpec':
        seo = genProductSpec(locale, meta);
        jsonld = [
            ...jsonld,
            genProductSpecJSONLd(meta),
            genBreadCrumb([
                {
                    url: meta.categoryData.url,
                    name: meta.categoryData.name,
                },
                {
                    url: meta.productData.url,
                    name: meta.productData.name,
                },
                {
                    url: meta.fullSiteUrl,
                    name: meta.specName,
                },
            ]),
        ];
        break;
    default:
        seo = genDefault(locale);
        break;
    }
    return {
        ...seo,
        url: pageUrl,
        jsonld,
        canonicalUrl,
    };
};

module.exports = genSEO;
